// extracted by mini-css-extract-plugin
export const cancelButton = "CancelButton__cancelButton__ddukY";
export const link = "CancelButton__link__Zktti";